import React, { useContext } from 'react';
import ChatBotWindow from '../chatbot/ChatBotWindow';
import { TbArrowsDiagonalMinimize } from 'react-icons/tb';
import { RiRobot2Fill } from 'react-icons/ri';
import { ChatBotContext } from '../../context/ChatBotContext';
export const Chatbot = () => {
    const { show, setShow } = useContext(ChatBotContext);
    return (
        <div className={show ? 'fixed bottom-0 right-0 z-3 h-auto w-auto' : 'fixed bottom-0 right-0 z-3'}>
            {show ?
                <div className='chatwindow-container fixed bottom-0 right-0 h-[50%] max-h-[calc(100vh-10px)] w-screen flex flex-col justify-end'>
                    <div className='flex-none bg-black text-white items-end rounded-tl-xl rounded-tr-xl cursor-pointer h-4'>
                        <TbArrowsDiagonalMinimize className=' w-full h-full'
                            onClick={() => { setShow(!show); }}/>
                    </div>
                    <ChatBotWindow className='flex-grow bg-white'/>
                </div>
                : (
                    <div className='chatbot-icon-container fixed bottom-2 right-2'>
                        <RiRobot2Fill className={show ? 'hidden' : ' ' + ' cursor-pointer pointer-events-auto fixed bottom-2 right-2'} size={45} onClick={() => setShow(!show)} />
                    </div>
                )
            }
        </div>
    );
};
